import React from 'react'
import {CallModalContainer} from '../ui/onboarding-program'
import {ParagraphText} from '@thryvlabs/maverick'
import ConfirmedCall from './confirmed-call'
import UnconfirmedCall from './unconfirmed-call'

export default function CallSection({
  apptData,
  defaultCentersAndApps,
  selectedCentersAndApps,
  isLoading,
  shouldEnableCreativeCallModal,
  includeAddonsCodes,
  industryCategoryType,
  isRestrictedAccessHIPPASelected,
  noneCustomVideoCreativeItem,
  isMCSelected,
  isUsSpanishOptionAvailable,
  accountInformation,
  register,
  errors,
  isThryvLeadsOrSeoIncluded,
  defaultDate,
  onboardingCallDate,
  upgradeAccountInfo,
  selectedAddons,
  isNewTLMCAccessible,
  keapAccount,
  isMCAlreadyIncluded,
  pre5SeoOffsetStartDay,
}) {
  let is4VNewSEOExist
  let isThryvLeads
  let seoBillingDate
  if (selectedAddons) {
    is4VNewSEOExist = selectedAddons.find(item => {
      return (
        ['addon-4-seobase-m2m'].includes(item?.planCode) &&
        item?.tempLineActionCode === 'New'
      )
    })
    seoBillingDate = is4VNewSEOExist?.seoBillingDate
    // logc updated to have tl-mc-code udpated
    if (selectedAddons && isNewTLMCAccessible) {
      isThryvLeads = selectedAddons.find(
        item =>
          item?.planCode?.includes('tl-') && item?.tempLineActionCode === 'New',
      )
    }
    if (isThryvLeads) {
      isThryvLeads = true
    }
    //
  }
  const title = {
    kickoff: 'Kickoff',
    creative: 'Creative',
    'thryv-success-services': 'Success Services',
  }
  return (
    <CallModalContainer isCC={selectedCentersAndApps}>
      {!selectedCentersAndApps && apptData.callType === 'creative' && <hr />}
      <ParagraphText
        variant="lg"
        color={
          apptData.callConfirmed && selectedCentersAndApps
            ? ''
            : 'thryv-gray-medium-500'
        }
        style={{
          fontWeight:
            apptData.callConfirmed && selectedCentersAndApps ? '600' : 'normal',
          width: '100%',
        }}
      >
        Thryv {title[apptData.callType]} Call{' '}
        {apptData.languagePreference.value && (
          <span>
            <strong> (Spanish)</strong>
          </span>
        )}{' '}
        {/* {isUpgrade &&
          !isSyncUpgrade &&
          !selectedCentersAndApps &&
          apptData.callType === 'kickoff' &&
          !apptData.isOnboardingRequired4Upgrade &&
          !is4VNewSEOExist &&
          !isThryvLeads && (
            <span>
              <strong>(Optional!)</strong>
            </span>
          )} */}
      </ParagraphText>
      {apptData.callConfirmed || apptData.isApptSkipped ? (
        <ConfirmedCall
          callType={apptData.callType}
          callDate={apptData.callDate}
          isApptSkipped={apptData.isApptSkipped}
          selectedCentersAndApps={selectedCentersAndApps}
          cancelAppointment={apptData.cancelAppointment}
          selectedService={apptData.selectedService}
          apptId={apptData.apptId}
        />
      ) : (
        <UnconfirmedCall
          apptData={apptData}
          defaultCentersAndApps={defaultCentersAndApps}
          selectedCentersAndApps={selectedCentersAndApps}
          selectedAddons={selectedAddons}
          isLoading={isLoading}
          shouldEnableCreativeCallModal={shouldEnableCreativeCallModal}
          includeAddonsCodes={includeAddonsCodes}
          industryCategoryType={industryCategoryType}
          isRestrictedAccessHIPPASelected={isRestrictedAccessHIPPASelected}
          noneCustomVideoCreativeItem={noneCustomVideoCreativeItem}
          isMCSelected={isMCSelected}
          isUsSpanishOptionAvailable={isUsSpanishOptionAvailable}
          accountInformation={accountInformation}
          selectedService={apptData.selectedService}
          register={register}
          errors={errors}
          apptId={apptData.apptId}
          isThryvLeadsOrSeoIncluded={isThryvLeadsOrSeoIncluded}
          defaultDate={defaultDate}
          onboardingCallDate={onboardingCallDate}
          // new inclusion for tl-mc
          isThryvLeads={isThryvLeads}
          isNewTLMCAccessible={isNewTLMCAccessible}
          //
          keapAccount={keapAccount}
          seoBillingDate={seoBillingDate}
          newSEO4v={is4VNewSEOExist}
          isMCAlreadyIncluded={isMCAlreadyIncluded}
          pre5SeoOffsetStartDay={pre5SeoOffsetStartDay}
        />
      )}
    </CallModalContainer>
  )
}
